import { Pipe, PipeTransform } from '@angular/core';
import { Entry_type } from '../models/entry_type';

@Pipe({
  standalone: false,
  name: 'entryTypeWoHorse'
})
export class EntryTypeWoHorsePipe implements PipeTransform {

	transform(entryTypes: Entry_type[]): any {
     	return entryTypes.filter(entry_type => (entry_type.enter_wo_horse && entry_type.barn_account == false));
  	}

}
